// React
import React from "react";
// redux hooks
import { Controller } from "react-hook-form";
// material-ui components
import Divider from '@mui/material/Divider';
import TextField from "@mui/material/TextField";
import Timeline from '@mui/lab/Timeline';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import WYSIWYGEditor from "../../../../../../../../shared-components/WYSIWYGEditor";
// custom components
import NumberedHeading from '../../../../../../../../shared-components/forms/NumberedHeading';

const PEFaceToFaceEnvDesc = ({control, errors, inputDir}) => {

  return (
    <>
      <Timeline
        sx={{
          [`& .${timelineItemClasses.root}:before`]: {
            flex: 0,
            padding: 0,
          },
        }}
        className="px-0"
      >
        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot color="secondary" />
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent className="pr-0">
            <div>
              <NumberedHeading number='1' title="Character Name" instructions='Please enter a name for the character you are having a face to face dialog with.' required />
              <Controller 
                control={control}
                name="content.env_desc.character_name"
                render={({ field }) => (
                  <TextField
                    {...field}
                    className="mt-16 mb-16"
                    label="Character Name"
                    placeholder="John Doe"
                    error={!!errors?.character_name}
                    helperText={errors?.character_name?.message}
                    fullWidth
                    required
                    dir={inputDir}
                    size="small"
                  />
                )}
              />

              <Divider className="my-16" />

              <NumberedHeading number='2' title="Character Description" instructions='Please enter a description for the character you are having a face to face dialog with.' required />
              <Controller
                control={control}
                name="content.env_desc.character_desc"
                render={({ field }) => <WYSIWYGEditor {...field} error={errors ? errors.character_desc : undefined} />}
              />

              <Divider className="my-16" />

              <NumberedHeading number='3' title="Character Image URL" instructions='Please enter URL for the character image you are having a face to face dialog with. Leave this for Devs' />
              <Controller 
                control={control}
                name="content.env_desc.character_img_url"
                render={({ field }) => (
                  <TextField
                    {...field}
                    className="mt-16 mb-16"
                    label="Character Image URL"
                    placeholder="John Doe"
                    error={!!errors?.character_img_url}
                    helperText={errors?.character_img_url?.message}
                    fullWidth
                    size="small"
                  />
                )}
              />

              <Divider className="my-16" />

              <NumberedHeading number='4' title="Scene Description" instructions='Please enter a description for the scene you are having a face to face dialog in.' required />
              <Controller
                control={control}
                name="content.env_desc.scene_desc"
                render={({ field }) => <WYSIWYGEditor {...field} error={errors ? errors.scene_desc : undefined} />}
              />
              
              
            </div>
          </TimelineContent>
        </TimelineItem>
      </Timeline>
    </>
  );
}

export default PEFaceToFaceEnvDesc;